import {
  cta_buttonPrimaryText,
  cta_buttonSecondaryText,
  cta_linkTextAlert,
} from 'ext-ui/style/colors'
import { processing_spinSpeed } from 'ext-ui/style/transitionSpeeds'
import { css, keyframes } from 'styled-components'

const spinningAnimation = keyframes`
  0% {
    transform:rotate(0deg);
  }
  100% {
    transform:rotate(360deg);
  }
`

export default css`
  animation: ${spinningAnimation} ${processing_spinSpeed} infinite linear;

  &.primary {
    & > * {
      fill: ${cta_buttonSecondaryText};
    }
  }

  &.secondary {
    & > * {
      fill: ${cta_buttonPrimaryText};
    }
  }

  &.severe {
    & > * {
      fill: ${cta_linkTextAlert};
    }
  }
`
